// extracted by mini-css-extract-plugin
export default {"content":"ProjectGiraffePage_content__5uQr6","featuresList":"ProjectGiraffePage_featuresList__zXt+M"};